/**
 * This file contains authentication parameters. Contents of this file
 * is roughly the same across other MSAL.js libraries. These parameters
 * are used to initialize Angular and MSAL Angular configurations in
 * in app.module.ts file.
 */

import { Configuration, BrowserCacheLocation, LogLevel } from '@azure/msal-browser';
import { environment } from 'src/environments/environment';

const isIE = window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1;

/**
 * Enter here the user flows and custom policies for your B2C application,
 * To learn more about user flows, visit https://docs.microsoft.com/en-us/azure/active-directory-b2c/user-flow-overview
 * To learn more about custom policies, visit https://docs.microsoft.com/en-us/azure/active-directory-b2c/custom-policy-overview
 */
export const b2cPolicies = {
    names: {
        signUpSignIn: 'b2c_1_signupsigninflow',
        resetPassword: 'b2c_1_signupsigninflow',
        editProfile: 'b2c_1_signupsigninflow',
        signOut: 'b2c_1_signupsigninflow'
    },
    authorities: {
        signUpSignIn: {
            authority: 'https://b2c-devtest.eurocontrol.int/b2c-devtest.eurocontrol.int/b2c_1_signupsigninflow/',
        },
        resetPassword: {
            authority: 'https://b2c-devtest.eurocontrol.int/b2c-devtest.eurocontrol.int/b2c_1_signupsigninflow/',
        },
        editProfile: {
            authority: 'https://b2c-devtest.eurocontrol.int/b2c-devtest.eurocontrol.int/b2c_1_signupsigninflow/',
        },
        signOut: {
            authority: 'https://b2c-devtest.eurocontrol.int/b2c-devtest.eurocontrol.int/b2c_1_signupsigninflow/oauth2/v2.0/logout'
        }
    },
    authorityDomain: 'https://b2c-devtest.eurocontrol.int',
};

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig: Configuration = {
    auth: {
        clientId: environment.b2cClientId,
        authority: b2cPolicies.authorities.signUpSignIn.authority, // Defaults to "https://login.microsoftonline.com/common"
        knownAuthorities: [b2cPolicies.authorityDomain],
        redirectUri: '/',  // Points to window.location.origin by default. You must register this URI on Azure portal/App Registration.
        postLogoutRedirectUri: '/',  // Redirect to login page after logout. Points to window.location.origin by default.

    },
    cache: {
        cacheLocation: BrowserCacheLocation.SessionStorage,
        //storeAuthStateInCookie: isIE,
    },
    system: {
        loggerOptions: {
            loggerCallback(logLevel: LogLevel, message: string) {
                console.log(message);
            },
            logLevel: LogLevel.Verbose,
            piiLoggingEnabled: false
        }
    }
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    // scopes: [`https://b2c-devtest.eurocontrol.int/${clientId}/APPROVALUSERROLE`]
    // scopes: [`openid`]
    //scopes: [`https://b2c-devtest.eurocontrol.int/${clientId}/scdma_access`]
    scopes: []
};

/**
 * An optional silentRequest object can be used to achieve silent SSO
 * between applications by providing a "loginHint" property (such as a username). For more, visit:
 * https://learn.microsoft.com/en-us/azure/active-directory/develop/msal-js-sso#sso-between-different-apps
 * If you do not receive the username claim in ID tokens, see also:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/FAQ.md#why-is-getaccountbyusername-returning-null-even-though-im-signed-in
 */
export const silentRequest = {
    scopes: [],
    loginHint: ""
};
